import { SingleFleetGroupFilterValue, SingleFilterValue, SingleStringFilterValue } from 'ais-facade-api/api';
import { useMemo } from 'react';

export const useGetAllValue = (
  valuesArray?: Array<SingleFilterValue | SingleStringFilterValue | SingleFleetGroupFilterValue>,
) => {
  return useMemo(
    () =>
      valuesArray
        ?.reduce(
          (acc: Array<number | string>, cur: SingleFilterValue | SingleStringFilterValue | SingleFleetGroupFilterValue) => {
            if ('values' in cur && cur.values) {
              return [...acc, ...cur.values];
            }
            if ('key' in cur && cur.key) {
              return [...acc, cur.key];
            }
            return [...acc];
          },
          [],
        )
        .map((e: number | string) => String(e)),
    [valuesArray],
  );
};
